import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Curtain } from './components/Curtain';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BrandPromise } from './components/BrandPromise';
import { Highlights } from './components/Highlights';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Founders } from './components/Founders';
import { SectionTransition } from './components/SectionTransition';
import { WhyWeWin } from './components/WhyWeWin';
import { Schedule } from './components/Schedule';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { Seo } from './components/Seo';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="28s2z1ddy01vz">
      <div className="w-full bg-ink-900 font-sans antialiased" data-id="element-1" data-mp="23vune9yyeqtk">
        <Seo data-id="element-2" data-mp="23t8ea5wf0398" />
        <Curtain data-id="element-3" data-mp="3ijxnsm94vshs" />
        <Navbar data-id="element-4" data-mp="3ikha0f5th31m" />
        <main data-id="element-5" data-mp="3iiweonbohg2p">
          <Hero data-id="element-6" data-mp="3ijfwm41bw4gq" />
          <Highlights data-id="element-7" data-mp="3ijpef4c7z5bc" />
          <Services data-id="element-8" data-mp="3mlj8gtrwtb2j" />
          <Testimonials data-id="element-9" data-mp="3ml1234bj9ggw" />
          <SectionTransition data-id="element-10" data-mp="3mk852v2dm5by" />
          <Founders data-id="element-11" data-mp="3mjg93j4va5l5" />
          <WhyWeWin data-id="element-12" data-mp="3rc9i4j7dc031" />
          <BrandPromise data-id="element-13" data-mp="3rbzmaezn6ypf" />
          <Schedule data-id="element-14" data-mp="3rdkkqfp2v1sk" />
          <Contact data-id="element-15" data-mp="3recdzjv7cnfo" />
        </main>
        <Footer data-id="element-16" data-mp="5opiv1o0k3w" />
        <FloatingWhatsApp data-id="element-17" data-mp="680frswe88f" />
      </div>
    </LanguageProvider>;
}